import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  modalPaper: {
    borderRadius: "18px",
    boxShadow: "0 8px 32px rgba(0, 0, 0, 0.12)",
    border: "1px solid rgba(255, 255, 255, 0.18)",
    background:
      "linear-gradient(135deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.7))",
    backdropFilter: "blur(10px)",
  },

  modalTitle: {
    background: "#fff !important",
    color: "white",
    padding: "20px 24px",
    borderTopLeftRadius: "12px",
    borderTopRightRadius: "12px",
    "& .MuiTypography-root": {
      fontWeight: 600,
    },
  },

  warningIcon: {
    fontSize: "28px",
    color: "#ffc400ff",
  },

  modalContent: {
    background: "#fff !important",

    padding: "24px",
    textAlign: "center",
  },

  message: {
    marginBottom: "16px",
    lineHeight: 1.6,
    color: "#2c3e50",
    fontSize: "16px",
  },

  note: {
    paddingTop: "1vh",
    color: "#7f8c8d",
    fontStyle: "italic",
    fontSize: "14px",
  },

  modalActions: {
    padding: "16px 24px 24px",
    justifyContent: "center !important",
    display: "flex",
    flex: 1,
    background: "#fff !important",
  },

  confirmButton: {
    background: "#4D6BF6",
    color: "white",
    padding: "10px 32px",
    borderRadius: "8px",
    fontWeight: 600,
    textTransform: "none",
    fontSize: "16px",
    marginBottom: "1vh",
    boxShadow: "none",
  },
}));

export default useStyles;
